const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5991bf374934f0c8e2ae0793490649d74c61c5e6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend@anothernoob"]={id:"5991bf374934f0c8e2ae0793490649d74c61c5e6"};
      